/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Fast Advance Invoice Buttons component
 *
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.36.0
 */

import { FC } from 'react';

import { useSelector } from 'react-redux';

import MobileCashModal from '@/main/components/Table/components/footerModal/MobileCashModal';
import { makeSelectTranslationPagePersonalAccount } from '@/main/modules/internationalization/intSelectors';

interface IFastInquiryCreateButtonsProps {
    clientId: string;
    onCloseModal: () => void;
    applyButtonTooltip?: string;
}



export const FastAdvanceInvoiceButtons: FC<IFastInquiryCreateButtonsProps> = (
    { clientId, onCloseModal, applyButtonTooltip },
) => {

    const { tableFooter } = useSelector(makeSelectTranslationPagePersonalAccount());

    return (
        <>
            <MobileCashModal 
                disableIfNoClientId
                dontCloseOnApply
                titleIsHidden
                applyButtonTooltip={applyButtonTooltip}
                clientId={clientId}
                closeButtonText={tableFooter.cancel}
                onCloseModal={onCloseModal}
            />
        </>
    )};
